import Immutable from 'seamless-immutable'
import { createAction, handleActions } from 'redux-actions'

import { AppThunk } from '..'
import * as actionTypes from '../action-types'
import { getIsLoading } from '../threeviewer/files/selectors'

const _setDirty = createAction(actionTypes.SET_DIRTY)
export const clearDirty = createAction(actionTypes.CLEAR_DIRTY)

export function setDirty (): AppThunk {
  return (dispatch, getState) => {
    const state = getState()
    if (
      getIsLoading(state) ||
      state.threeviewer.camera.isProgrammaticCameraMove
    ) {
      return
    }

    dispatch(_setDirty())
  }
}

const initialState = Immutable<{
  isDirty: boolean
}>({
  isDirty: false,
})

type State = typeof initialState

const syncIsDirty = (state: State, action: any) =>
  action.payload.affectsDirty ? state.setIn(['isDirty'], true) : state

export default handleActions<State, any>({
  [_setDirty.toString()]: (state) => state.setIn(['isDirty'], true),
  [clearDirty.toString()]: (state) => state.setIn(['isDirty'], false),
  [actionTypes.UNDO.toString()]: syncIsDirty,
  [actionTypes.REDO.toString()]: syncIsDirty,
  [actionTypes.ADD_COMMAND.toString()]: (state, action) => action.payload.command.affectsDirty ? state.setIn(['isDirty'], true) : state,
}, initialState)
